<template>
  <div class="payment">
    <div class="head row align-center column-s">
      <h1 class="grid-3 grid-12-s text-center-s">Pagamentos</h1>
      <div
        class="filters row grid-8-m grid-9-g grid-11-s justify-around column-s align-end"
      >
        <div class="fil grid-3 grid-12-s column">
          <label>Nota Fiscal</label>
          <select v-model="filters.status_nota_fiscal" class="input">
            <option value="">Selecione</option>
            <option value="validado">Validada</option>
            <option value="pendente">Pendente</option>
          </select>
        </div>
        <div class="fil grid-3 grid-12-s column">
          <label>Pagamento</label>
          <select v-model="filters.status_pagamento" class="input">
            <option value="">Selecione</option>
            <option value="pago">Pago</option>
            <option value="pendente">Pendente</option>
          </select>
        </div>
        <div class="fil grid-3 grid-12-s column">
          <label>Inicio Pagamento</label>
          <input
            v-model="filters.data_inicio"
            type="date"
            class="input"
            placeholder="Inicio Pagamento"
          />
        </div>
        <div class="fil grid-3 grid-12-s column">
          <label>Fim Pagamento</label>
          <input
            v-model="filters.data_fim"
            type="date"
            class="input"
            placeholder="Fim Pagamento"
          />
        </div>
        <div class="fil grid-3 grid-12-s row justify-center-s">
          <Button layout="green-go" @click="load()" :loader="loader"
            ><i class="fa fa-filter" /> GERAR</Button
          >
          <Button layout="green-go" @click="cnab()" :loader="loader"
            ><i class="fa fa-file" /> REMESSA</Button
          >
        </div>
      </div>
    </div>
    <div v-if="list.pagamentos" class="list">
      <div v-if="loader" class="column align-center justify-center">
        <Loader layout="small" />
      </div>
      <template v-else>
        <div class="sub row grid-12-s column-s">
          <input class="input search" v-model="search" placeholder="Pesquisar" />
          <div class="row grid-9 justify-end">
            <div class="grid-2 column grid-12-s text-center-s">
              Jobs <b>{{ list.qtd_jobs }}</b>
            </div>
            <div class="grid-2 grid-12-s column grid-12-s text-center-s">
              Supporters <b>{{ list.qtd_doutor }}</b>
            </div>
            <div class="grid-3 grid-6-m grid-12-s column grid-12-s text-center-s">
              Total <b>{{ list.total_pagamentos | money }}</b>
            </div>
          </div>
          <Button layout="green-go" @click="csv()" :loader="loader"
            ><i class="fa fa-filter" /> GERAR CSV</Button
          >
        </div>
        <div class="container">
          <div class="head row justify-space">
            <div class="grid-2">Nome</div>
            <div class="grid-2">E-mail</div>
            <div class="grid-2">CPF/CNPJ</div>
            <div class="grid-3">Razão Social</div>
            <div class="grid-2">Banco</div>
            <div class="grid-1">Valor</div>
          </div>
          <div class="content">
            <div
              v-for="(item, i) of filtered"
              :key="'item' + i"
              class="line row justify-space"
            >
              <div class="grid-2">{{ item.id_doutor + " " + item.nome_doutor }}</div>
              <div class="grid-2">{{ item.email_doutor }}</div>
              <div class="grid-2">
                {{ item.cpf | cpf
                }}<template
                  v-if="item.cpf && item.cpf != null && item.cnpj && item.cpf != null"
                  >/ </template
                >{{ item.cnpj | cnpj }}
              </div>
              <div class="grid-3">{{ item.razao_social }}</div>
              <div class="grid-2">
                <b>{{ item.nome_banco }}</b
                ><br />
                Código: <b>{{ item.codigo_banco }}</b
                ><br />
                Tipo: <b>{{ item.tipo_conta }}</b
                ><br />
                Agência:
                <b
                  >{{ item.agencia_banco
                  }}{{ item.dv_agencia_banco ? "-" + item.dv_agencia_banco : "" }} </b
                ><br />
                Conta:
                <b
                  >{{ item.conta_banco
                  }}{{ item.dv_conta_banco ? "-" + item.dv_conta_banco : "" }} </b
                ><br />
                <template v-if="item.operacao_conta">
                  Operação: <b>{{ item.operacao_conta }}</b>
                </template>
                Titular:
                <b>
                  {{ item.titular_conta }}
                </b>
              </div>

              <div class="grid-1">{{ item.total_pagamento | money }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";

export default {
  name: "Payment",
  components: {
    Button,
    Loader,
  },
  data() {
    return {
      loader: false,
      search: "",
      csvButton: false,
      filters: {
        status_pagamento: "",
        status_nota_fiscal: "",
        data_inicio: "",
        data_fim: "",
      },
      list: {},
    };
  },
  methods: {
    ...mapActions("admin", ["PAYMENT_CICLE", "PAYMENT_CNAB"]),
    async load() {
      this.list.pagamentos = [];
      this.loader = true;

      let url = "";
      for (let i in this.filters) if (this.filters[i]) url += `&${i}=${this.filters[i]}`;

      await this.PAYMENT_CICLE(url)
        .then(({ data }) => (this.list = data || {}))
        .catch(() => {
          this.loader = false;
          this.list = {};
        });

      this.loader = false;
    },
    async cnab() {
      this.loader = true;

      let url = "";
      for (let i in this.filters) if (this.filters[i]) url += `&${i}=${this.filters[i]}`;

      await this.PAYMENT_CNAB(url)
        .then(({ data }) => {
          var cnab = document.createElement("a");
          cnab.download = data.nome;
          cnab.href = `data:text/plain;base64,${data.cnab240}`;
          cnab.click();
        })
        .catch(() => {
          this.loader = false;
        });
      this.loader = false;
    },
    async csv() {
      let csv =
        "ID, NOME, E-MAIL, CPF, CNPJ, RAZÃO SOCIAL, COD BANCO, BANCO, AGENCIA, DIG AGENCIA, TIPO CONTA, CONTA, DIG CONTA, OPERACAO CONTA, TITULAR, TOTAL PAGAMENTO\n";

      this.list.pagamentos.map((item) => {
        csv += `${item.id_doutor}, ${item.nome_doutor}, ${item.email_doutor}, ${item.cpf}, ${item.cnpj}, ${item.razao_social}, ${item.codigo_banco}, ${item.nome_banco}, ${item.agencia_banco}, ${item.dv_agencia_banco}, ${item.tipo_conta}, ${item.conta_banco}, ${item.dv_conta_banco}, ${item.operacao_conta}, ${item.titular_conta}, ${item.total_pagamento}\n`;
      });

      var acsv = document.createElement("a");
      acsv.download = "relatorio-extrato-faturamento.csv";
      acsv.href = `data:application/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      acsv.click();
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("payment");
  },
  computed: {
    filtered() {
      if (this.search) {
        const search = this.search.toLowerCase();

        return this.list.pagamentos.filter((part) => {
          let partsSerialize = JSON.stringify(part).toLowerCase();
          return partsSerialize.includes(search);
        });
      } else {
        return this.list.pagamentos;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.payment
  @include page
  .head
    label
      @include label
  .list
    font-size: 13px
    .container
      overflow-x: auto
      .head,.content
        min-width: 1200px
        word-wrap: break-word
  .filters
    .fil
      padding: 0 6px
      input[type="date"]
          width: 92%
      @media (max-width: $small)
        margin-bottom: 23px
    button
      height: 50px
      min-width: 145px
      margin-left: 12px
  .sub
    font-size: 13px
    color: $purple
    margin-bottom: 35px
    b
      color: $font-color
      font-size: 29px
      font-weight: bold
    button
      width: 200px
      height: 40px
      margin-left: 23px
</style>
